import Container from '@admin/components/container'
import Search from '@admin/components/search'
import Loader from '@admin/components/loader'
import Chart from '@admin/components/chart'
import Icon from '@admin/components/icon'
import EmailCampaignToken from './token'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import moment from 'moment'
import React from 'react'
import qs from 'qs'

class Card extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    network: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    config: PropTypes.object,
    daterange: PropTypes.object,
    data: PropTypes.object,
    email_campaign: PropTypes.object,
    isExpanded: PropTypes.bool,
    program: PropTypes.object,
    showChart: PropTypes.bool,
    showTable: PropTypes.bool
  }

  state = {
    email_campaign_id: null,
    data: null
  }

  _handleChoose = this._handleChoose.bind(this)

  render() {
    const { showChart, showTable } = this.props
    const { data } = this.state
    const keys = this._getKeys()
    if(!data) return <Loader />
    const metric = this._getMetric(data)
    return (
      <div className="maha-dashboard-card-body">
        { showTable && 
          <div className="maha-dashboard-card-sidebar">
            <Search { ...this._getSearch() } />
          </div>
        }
        <div className="maha-dashboard-card-detail">
          <div className="maha-dashboard-card-detail-header">
            <div className="maha-dashboard-card-detail-title">
              <T text={ this._getLabel(keys.title) } />
            </div>
            <div className="maha-dashboard-card-detail-subtitle">
              { data.summary.label }
            </div>
            <div className="maha-dashboard-card-detail-metric">
              <div className="maha-dashboard-card-detail-metric-inner">
                <div className="maha-dashboard-card-detail-metric-text">
                  { metric.value }
                </div>
                { metric.delta &&
                  <div className={`maha-dashboard-card-detail-metric-delta ${ metric.delta.direction }`}>
                    <Icon icon={`caret-${ metric.delta.direction }`} /> { metric.delta.percent }
                  </div>
                }
              </div>
            </div>
          </div>
          { showChart &&
            <div className="maha-dashboard-card-detail-chart">
              <Chart { ...this._getChart(keys, data) } />
            </div>
          }
          { showTable &&
            <div className="maha-dashboard-card-detail-table">
              <table>
                <thead>
                  <tr>
                    <th><T text="t(Date)" /></th>
                    <th><T text="t(Rate)" /></th>
                  </tr>
                </thead>
                <tbody>
                  { data.details.map((record, index) => (
                    <tr key={`record_${index}`} onClick={ this._handleClick.bind(this, keys.amount, record) }>
                      <td>{ record.label }</td>
                      <td>
                        <div className="maha-dashboard-card-detail-amount">{ record.value }</div>
                        <div className="maha-dashboard-card-detail-percent">({ numeral(record.rate).format('0.00%') })</div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          }
        </div>
      </div>
    )
  }

  componentDidMount() {
    this._handleFetch()
  }

  componentDidUpdate(prevProps, prevState) {
    const { email_campaign_id } = this.state
    if(email_campaign_id !== prevState.email_campaign_id) {
      this._handleFetch()
    }
  }

  _getChart(keys, data) {
    const { config, isExpanded } = this.props
    return {
      type: config.type,
      datasets: [
        {
          color: config.color,
          label: 'Rate',
          points: data.details.map(record => ({
            x: record.label,
            y: numeral(record.rate * 100).format('0.00')
          }))
        }
      ],
      options: {
        aspectRatio: isExpanded ? 2 : 1.5,
        points: config.points,
        tension: config.tension,
        grid: isExpanded
      }
    }
  }

  _getKeys() {
    const { metric } = this.props.config
    return {
      ...metric === 'bounce_rate' ? {
        title: 't(Bounce Rate)',
        amount: 'bounced',
        rate: 'bounce_rate'
      } : metric === 'click_rate' ? {
        title: 't(Click Rate)',
        amount: 'clicked',
        rate: 'click_rate'
      } : metric === 'complain_rate' ? {
        title: 't(Complain Rate)',
        amount: 'complained',
        rate: 'complain_rate'
      } : metric === 'open_rate' ? {
        title: 't(Open Rate)',
        amount: 'opened',
        rate: 'open_rate'
      } : metric === 'unsubscribe_rate' ? {
        title: 't(Unsubscribe Rate)',
        amount: 'unsubscribed',
        rate: 'unsubscribe_rate'
      } : metric === 'delivery_rate' ? {
        title: 't(Delivery Rate)',
        amount: 'delivered',
        rate: 'delivery_rate'
      } : {}
    }
  }

  _getLabel(label) {
    const { config, email_campaign, program } = this.props
    const { team } = this.context.admin
    if(config.title) return config.title
    if(config.scope === 'program' && team.has_programs) return `${label} - ${program.title}`
    if(config.scope === 'email_campaign') return `${label} - ${email_campaign.title}`
    return label
  }

  _getMetric(data) {
    const { current_rate, previous_rate, delta } = data.summary
    const percent = delta === 0 ? null : previous_rate === 0 ? 1 : Math.abs((delta) / previous_rate)
    return {
      value: numeral(current_rate).format('0.00%'),
      delta: percent > 0 ? {
        direction: delta < 0 ? 'down' : 'up',
        percent: percent && percent !== 0 ? numeral(percent).format('0.00%') : null
      } : null
    }
  }
  
  _getSearch() {
    const { config, daterange } = this.props
    return {
      endpoint: '/api/admin/dashboards/campaigns/email_campaign_metric/campaigns',
      valueKey: 'id',
      textKey: 'title',
      deselectable: true,
      defaultQuery: {
        metric: config.metric,
        program_id: config.program_id,
        daterange 
      },
      entity: 't(email campaign)',
      format: (email_campaign) => (
        <EmailCampaignToken email_campaign={ email_campaign }/>
      ),
      onChange: this._handleChoose
    }
  }

  _handleChoose(email_campaign_id) {
    this.setState({ 
      email_campaign_id: email_campaign_id || null
    })
  }

  _handleClick(metric, record) {
    const { email_campaign, program } = this.props
    const filter = qs.stringify({
      metric,
      program_id: program.id,
      ...email_campaign ? { email_campaign_id: email_campaign.id } : {},
      start_date: moment.utc(record.start).format('YYYY-MM-DD'),
      end_date: moment.utc(record.end).format('YYYY-MM-DD')
    }, { encode: false })
    this.context.router.push(`/admin/dashboards/campaigns/email_campaign_metric?${filter}`)
  }

  _handleFetch() {
    const { config, daterange } = this.props
    const { email_campaign_id } = this.state
    this.context.network.request({
      endpoint: '/api/admin/dashboards/campaigns/email_campaign_metric/card',
      method: 'GET',
      filter: {
        metric: config.metric,
        email_campaign_id,
        program_id: config.program_id,
        daterange 
      },
      onSuccess: ({ data }) => {
        this.setState({ data })
      }
    })
  }

}

const mapResources = (props, context) => ({
  ...props.config.program_id ? {
    program: `/api/admin/team/programs/${props.config.program_id}`
  } : {}
})

export default Container(mapResources)(Card)
